import { render, staticRenderFns } from "./roll.vue?vue&type=template&id=78830055&scoped=true&"
import script from "./roll.vue?vue&type=script&lang=js&"
export * from "./roll.vue?vue&type=script&lang=js&"
import style0 from "./roll.vue?vue&type=style&index=0&id=78830055&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78830055",
  null
  
)

export default component.exports